module.exports = __webpack_public_path__ + "static/onDemandCoaching-7b24c2b829d121a5d52257e99abd9579.png";